import {
  getElectricLaytimeAPI,
  getElectricSofAPI,
  createElectricLaytimeAPI,
  createElectricSofAPI,
  updateElectricLaytimeAPI,
  updateElectricSofAPI,
  deleteElectricLaytimeAPI,
  deleteElectricSofAPI,
  createElectricLaytimePdfAPI,
  createElectricSofPdfAPI,
} from "./api";

export const getElectricLaytime = (query) => {
  return new Promise((resolve, reject) => {
    getElectricLaytimeAPI(query)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getElectricSof = (query) => {
  return new Promise((resolve, reject) => {
    getElectricSofAPI(query)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createElectricLaytime = (payload) => {
  return new Promise((resolve, reject) => {
    createElectricLaytimeAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createElectricLaytimePdf = (payload) => {
  return new Promise((resolve, reject) => {
    createElectricLaytimePdfAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createElectricSof = (payload) => {
  return new Promise((resolve, reject) => {
    createElectricSofAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createElectricSofPdf = (payload) => {
  return new Promise((resolve, reject) => {
    createElectricSofPdfAPI(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateElectricLaytime = (params, payload) => {
  return new Promise((resolve, reject) => {
    updateElectricLaytimeAPI(params, payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateElectricSof = (params, payload) => {
  return new Promise((resolve, reject) => {
    updateElectricSofAPI(params, payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteElectricLaytime = (params) => {
  return new Promise((resolve, reject) => {
    deleteElectricLaytimeAPI(params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteElectricSof = (params) => {
  return new Promise((resolve, reject) => {
    deleteElectricSofAPI(params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
